import { useState } from 'react';
import SectionTitle from '@/components/base/SectionTitle';
import Reveal from '@/components/base/Reveal';
import { homeFaqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20" id="faq">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="FAQ"
            title="关于围观，你想知道的"
            desc="关于内容来源、热度算法与评论管理的常见疑问，都在这里。"
            align="center"
          />
        </Reveal>

        <div className="mt-8 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
          {homeFaqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className="bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</h3>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}